var _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_36_1101)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_36_1101",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 102,
    height: 102
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0799 3.8458C76.0047 -0.999093 95.3145 12.0255 100.159 36.9503L102.911 51.1042C107.756 76.029 94.7309 95.3388 69.8061 100.184L55.6522 102.935C30.7274 107.78 11.4176 94.7552 6.57269 69.8304L3.82145 55.6765C-1.02344 30.7517 12.0012 11.4419 36.926 6.59703L51.0799 3.8458Z",
    fill: "url(#paint0_linear_36_1101)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_36_1101)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0799 3.8458C76.0047 -0.999093 95.3145 12.0255 100.159 36.9503L102.911 51.1042C107.756 76.029 94.7309 95.3388 69.8061 100.184L55.6522 102.935C30.7274 107.78 11.4176 94.7552 6.57269 69.8304L3.82145 55.6765C-1.02344 30.7517 12.0012 11.4419 36.926 6.59703L51.0799 3.8458Z",
    fill: "url(#paint1_linear_36_1101)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6855 18.7594C9.40408 24.8789 5.61987 35.2553 5.61987 40.7881C9.61578 39.9684 78.2635 26.034 92.5053 22.9602C86.5627 12.3044 76.4192 7.69378 69.6569 6.15689C62.8946 4.62 55.8249 5.43968 44.7593 7.69378C33.2381 10.0407 26.3166 10.6651 16.6855 18.7594Z",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.9588,
    cy: 49.8602,
    r: 3.27869,
    transform: "rotate(-11 17.9588 49.8602)",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.2226,
    cy: 47.6707,
    r: 3.27869,
    transform: "rotate(-11 29.2226 47.6707)",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.4876,
    cy: 45.4812,
    r: 3.27869,
    transform: "rotate(-11 40.4876 45.4812)",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.752,
    cy: 43.2914,
    r: 3.27869,
    transform: "rotate(-11 51.752 43.2914)",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.0159,
    cy: 41.1019,
    r: 3.27869,
    transform: "rotate(-11 63.0159 41.1019)",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.4598,
    cy: 62.7341,
    r: 3.27869,
    transform: "rotate(-11 20.4598 62.7341)",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.7249,
    cy: 60.5445,
    r: 3.27869,
    transform: "rotate(-11 31.7249 60.5445)",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.9901,
    cy: 58.3548,
    r: 3.27869,
    transform: "rotate(-11 42.9901 58.3548)",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.2543,
    cy: 56.1654,
    r: 3.27869,
    transform: "rotate(-11 54.2543 56.1654)",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.5184,
    cy: 53.9756,
    r: 3.27869,
    transform: "rotate(-11 65.5184 53.9756)",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.7828,
    cy: 51.7862,
    r: 3.27869,
    transform: "rotate(-11 76.7828 51.7862)",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.048,
    cy: 49.5964,
    r: 3.27869,
    transform: "rotate(-11 88.048 49.5964)",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.9622,
    cy: 75.6081,
    r: 3.27869,
    transform: "rotate(-11 22.9622 75.6081)",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.2274,
    cy: 73.4183,
    r: 3.27869,
    transform: "rotate(-11 34.2274 73.4183)",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.4925,
    cy: 71.2289,
    r: 3.27869,
    transform: "rotate(-11 45.4925 71.2289)",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.7567,
    cy: 69.0391,
    r: 3.27869,
    transform: "rotate(-11 56.7567 69.0391)",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.0204,
    cy: 66.8496,
    r: 3.27869,
    transform: "rotate(-11 68.0204 66.8496)",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.2852,
    cy: 64.6598,
    r: 3.27869,
    transform: "rotate(-11 79.2852 64.6598)",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.5505,
    cy: 62.4704,
    r: 3.27869,
    transform: "rotate(-11 90.5505 62.4704)",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.9948,
    cy: 84.1025,
    r: 3.27869,
    transform: "rotate(-11 47.9948 84.1025)",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.6734,
    cy: 86.3029,
    r: 3.27869,
    transform: "rotate(-11 36.6734 86.3029)",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.4092,
    cy: 88.4927,
    r: 3.27869,
    transform: "rotate(-11 25.4092 88.4927)",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.2592,
    cy: 81.9131,
    r: 3.27869,
    transform: "rotate(-11 59.2592 81.9131)",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.5233,
    cy: 79.7233,
    r: 3.27869,
    transform: "rotate(-11 70.5233 79.7233)",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 81.7877,
    cy: 77.5338,
    r: 3.27869,
    transform: "rotate(-11 81.7877 77.5338)",
    fill: "black",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.0529,
    cy: 75.344,
    r: 3.27869,
    transform: "rotate(-11 93.0529 75.344)",
    fill: "black",
    fillOpacity: 0.12
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_36_1101)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.3518,
    cy: 53.4357,
    rx: 35.9912,
    ry: 36.5655,
    transform: "rotate(3 53.3518 53.4357)",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_36_1101)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42.6801,
    y: 81.353,
    width: 2.68019,
    height: 30.3737,
    rx: 1.18862,
    transform: "rotate(-156.884 42.6801 81.353)",
    fill: "#222222",
    fillOpacity: 0.12
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_36_1101)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.9369,
    y: 74.0202,
    width: 2.6802,
    height: 30.3737,
    rx: 1.18862,
    transform: "rotate(137.153 73.9369 74.0202)",
    fill: "#222222",
    fillOpacity: 0.12
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_36_1101)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.4814,
    y: 24.178,
    width: 2.6802,
    height: 34.4596,
    rx: 1.18862,
    transform: "rotate(-27 36.4814 24.178)",
    fill: "#222222"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_36_1101)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.0007,
    y: 41.9308,
    width: 4.59462,
    height: 22.7667,
    rx: 1.18862,
    transform: "rotate(63 72.0007 41.9308)",
    fill: "#222222"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_36_1101)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 53.3421,
    cy: 53.627,
    r: 3.82885,
    transform: "rotate(3 53.3421 53.627)",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_36_1101",
    x: 2.69369,
    y: 2.71799,
    width: 101.345,
    height: 101.472,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.127229
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0636145
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_36_1101"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0636145
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_36_1101",
    result: "effect2_dropShadow_36_1101"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_36_1101",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_36_1101",
    x: 16.1908,
    y: 15.7036,
    width: 74.3219,
    height: 75.4642,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.583616
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_36_1101"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_36_1101",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_36_1101",
    x: 39.635,
    y: 51.7858,
    width: 15.5497,
    height: 30.1472,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.475449
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_36_1101"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_36_1101",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_36_1101",
    x: 50.8566,
    y: 51.2913,
    width: 23.54,
    height: 25.0112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.475449
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_36_1101"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_36_1101",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_36_1101",
    x: 35.9403,
    y: 22.4201,
    width: 19.1146,
    height: 33.0027,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.475449
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_36_1101"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_36_1101",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_36_1101",
    x: 51.1745,
    y: 41.3898,
    width: 23.4533,
    height: 15.5118,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.475449
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_36_1101"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_36_1101",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_36_1101",
    x: 48.3246,
    y: 48.6094,
    width: 10.0351,
    height: 10.0351,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.594311
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_36_1101"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_36_1101",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_36_1101",
    x1: 145.554,
    y1: 34.8878,
    x2: 35.142,
    y2: -39.1184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3374F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D3ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_36_1101",
    x1: 145.554,
    y1: 34.8878,
    x2: 35.142,
    y2: -39.1184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3374F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D3ED"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4585983b3cba01bcedb337f3402ef8c7.svg";
export { ForwardRef as ReactComponent };